<template>
  <div ref="mentionSelect" class="mentions-select-wrap">
    <u-input ref="inputRef" v-model="search" clearable>
      <template #suffix>
        <u-icon :size="14">
          <ULineSearch />
        </u-icon>
      </template>
    </u-input>
    <div class="mentions-select-content">
      <u-scrollbar max-height="200px">
        <div v-for="(item, index) in filterOptions" :key="index">
          <div
            class="select-item"
            :class="{ 'select-item-active': currentIndex === index }"
            @click="handleClick(item, index)"
          >
            <div class="text">
              <slot :data="item" name="label">
                <OneLineText :text="item?.label" />
              </slot>
              <u-tag
                v-if="item?.is_agent_variable"
                size="small"
                class="agent-tag"
                >agent</u-tag
              >
            </div>
            <span v-if="item?.type" class="item-type">{{ item.type }}</span>
          </div>
        </div>
      </u-scrollbar>
    </div>

    <div v-if="showNoData" class="no-more-wrap">
      {{
        $t(
          'components.RichMentions.components.MentionsSelect.8ca32e5c70ec23b34f25364f885e516d'
        )
      }}
    </div>
  </div>
</template>

<script setup>
import {
  shallowRef,
  inject,
  computed,
  nextTick,
  ref,
  onMounted,
  onBeforeUnmount
} from 'vue';
import { isEmpty } from 'lodash-es';
import { onClickOutside } from '@vueuse/core';
import OneLineText from '@/components/OneLineText.vue';
import { MentionsContextKey } from '../mentionsTypes';

const props = defineProps({
  options: {
    type: Array,
    default: () => []
  }
});
const emits = defineEmits(['close']);
const { setActiveIndex, selectOption } = inject(MentionsContextKey, {
  activeIndex: shallowRef()
});

const showNoData = computed(() => {
  return isEmpty(props.options);
});
const search = ref('');
const mentionSelect = ref(null);

const filterOptions = computed(() => {
  console.log(props.options, 'props.options');
  return props.options.filter(item => {
    return item.label.includes(search.value);
  });
});
onClickOutside(mentionSelect, () => {
  emits('close');
});
const handleClick = (item, index) => {
  if (setActiveIndex) {
    setActiveIndex(index);
  }

  nextTick(() => {
    if (selectOption) {
      selectOption(item);
    }
  });
};

const inputRef = ref(null);

const currentIndex = ref(0);

const handleKeydown = e => {
  if (!filterOptions.value.length) return;

  let selectedItem;

  switch (e.key) {
    case 'ArrowDown':
      e.preventDefault();
      currentIndex.value =
        (currentIndex.value + 1) % filterOptions.value.length;
      break;
    case 'ArrowUp':
      e.preventDefault();
      currentIndex.value =
        currentIndex.value - 1 < 0
          ? filterOptions.value.length - 1
          : currentIndex.value - 1;
      break;
    case 'Enter':
      e.preventDefault();
      selectedItem = filterOptions.value[currentIndex.value];
      handleClick(selectedItem, currentIndex.value);
      break;
    case 'Escape':
      e.preventDefault();
      emits('close');
      break;
    default:
      break;
  }
};

onMounted(() => {
  inputRef.value?.focus();
  window.addEventListener('keydown', handleKeydown);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown);
});
</script>

<style lang="less" scoped>
.mentions-select-wrap {
  // min-width: 100px;
  // max-width: 160px;
  width: 200px;
  overflow: hidden;
  box-shadow: 0 8px 26px 0 rgba(0, 0, 0, 16%);
  border-radius: 8px;
  z-index: 1000;
  color: var(--font-color);
  background: var(--color-filled-background-container-primary);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
  border: 1px solid var(--border-neutral-color-secondary);
  padding: 8px;
  .select-item {
    height: 32px;
    border-radius: 6px 6px 6px 6px;
    line-height: 32px;
    padding-left: 8px;
    padding-right: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    &:hover {
      background: var(--card-background-color);
      color: var(--active-font-color);
    }
  }
  .item-type {
    flex-shrink: 0;
    font-size: 11px;
    color: var(--color-text-icon-body-light-lin);
    background: var(
      --color-filled-background-container-secondary,
      rgba(0, 0, 0, 0.04)
    );
    border-radius: 3px;
    padding: 0 4px;
    line-height: 18px;
  }

  .select-item-active {
    background: var(--card-background-color);
    color: var(--active-font-color);
  }

  .text {
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    flex: 1;
    :deep(.one-line-text) {
      min-width: 0;
      width: auto;
      max-width: 100%;
    }
    .agent-tag {
      flex-shrink: 0;
    }
    .des {
      color: var(--primary-color);
    }
  }

  .no-more-wrap {
    padding-top: 12px;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.mentions-select-content {
  margin-top: 12px;
}
</style>
